import React, { FC, useEffect, useState } from 'react';
import { useHistory, useParams } from 'react-router';
import { Box, Spinner } from '@chakra-ui/react';

import { useHeader } from '@app/components/common/navigation/hooks/header-service';
import { useAlert, useApi, useGuide } from '@app/hooks';
import { Paper } from '@app/components/common/paper';

import DistributorForm from './form';
import { DistributorFormInstance } from './types';

const DistributorEdit: FC = () => {
  useHeader('Изменить дистрибьютора', []);
  const params = useParams<{ id: string }>();
  const api = useApi();
  const { error, success } = useAlert();
  const history = useHistory();
  const getStatuses = useGuide('distributor_status');

  const [instance, setInstance] = useState<
    Partial<DistributorFormInstance> | undefined
  >(undefined);
  const [loading, setLoading] = useState(false);
  const [fetching, setFetching] = useState(true);

  useEffect(() => {
    if (!params.id) {
      setFetching(false);
      return;
    }
    (async () => {
      setFetching(true);
      const res = await api.distributors.getDistributors({
        filter: { id: params.id },
        sort: '+id',
        limit: 1,
        offset: 0,
      });
      if (!res || res.code !== 200 || !res.data?.data?.[0]) {
        error('Дистрибьютор не найден');
        setFetching(false);
        setInstance(undefined);
        return;
      }
      const d = res.data.data[0];
      const statuses = await getStatuses();
      const status = statuses.find((s) => s.name === d.status);
      setInstance({
        id: d.id,
        name: d.name || '',
        legal_name: d.legal_name || '',
        legal_address: d.legal_address,
        description: d.description,
        phone: d.phone,
        email: d.email,
        inn: d.inn,
        tm: d.tm,
        rm: d.rm,
        channel: d.channel,
        sub_channel: d.sub_channel,
        status: status || null,
        address: {
          address: d.address,
          city: d.city,
          region: d.region,
        },
      });
      setFetching(false);
    })();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [params.id]);

  return (
    <Box paddingX={{ xs: 0, sm: 2, md: 10, lg: 14, xl: 20 }}>
      <Paper>
        <Box paddingX={4} paddingY={6}>
          {fetching || !instance ? (
            <Box
              width="100%"
              height="300px"
              display="flex"
              justifyContent="center"
              alignItems="center"
            >
              <Spinner />
            </Box>
          ) : (
            <DistributorForm
              loading={loading}
              instance={instance}
              submitText="Сохранить"
              onSubmit={async (payload) => {
                setLoading(true);
                const res = await api.distributors.updateDistributor(payload);
                if (!res || res.code !== 200) {
                  setLoading(false);
                  return;
                }
                setLoading(false);
                success('Дистрибьютор изменён');
                history.push('/distributors');
              }}
              onCancel={() => history.push('/distributors')}
            />
          )}
        </Box>
      </Paper>
    </Box>
  );
};

export default DistributorEdit;
